import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function HLWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1451">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1452">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1453">
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-1454">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-1455">
              <img src="https://cdn.magicpatterns.com/uploads/edrPpU513NQxZ6UneTChrm/BeClinical-Lifestyle-31-4-1.jpg" alt="Be CLINICAL Halo Laser Specialist" className="w-full h-full object-cover" data-id="element-1456" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-1457">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1458">
              WHY CHOOSE BE CLINICAL FOR HALO LASER SKIN RESURFACING?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-1459"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-1460">
              <p data-id="element-1461">
                At Be CLINICAL, we recognize the transformative impact of
                radiant skin on self-assurance and confidence. That's why our
                laser skin resurfacing treatments are meticulously tailored to
                not only improve your skin's texture and tone but also to
                amplify your inner confidence. Utilizing advanced Sciton laser
                systems and a personalized approach, we're dedicated to helping
                you attain the glowing skin you crave, empowering you to face
                each day with renewed vitality.
              </p>
              <p data-id="element-1462">
                Led by the expertise of Dr. Fiona Frie, our physician-owned and
                operated San Ramon clinic has upheld the principles of safety,
                quality, and efficacy since its establishment in 2017. Choose Be
                CLINICAL for a skincare journey that transcends the surface,
                rejuvenating both your skin and your spirit. We invite you to
                schedule your complimentary consultation today!
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1463">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}